import calEventFactory from './CalEventFactory';

/**
 * CalEventEditState — snapshot class for CalEvent edit form state.
 * Created from a CalEventObj via constructor — single source of truth for defaults.
 * Use isDirty(current) to compare against a second CalEventEditState instance.
 */
export default class CalEventEditState {
    /**
     * Creates a state snapshot from a CalEventObj.
     * For a brand new event (no rk yet), date/time default to now + 10 minutes
     * so the reminder picker opens with a sensible upcoming moment instead of empty fields.
     * All other fields fall back to safe defaults when event is null or undefined.
     * @param {CalEventObj|null} event
     */
    constructor(event) {
        const isNew = !event?.rk;
        const defaults = isNew ? calEventFactory.defaultDateTime() : null;

        this.label = event?.label ?? '';
        this.date = event?.date ?? defaults?.date ?? '';
        this.time = event?.time ?? defaults?.time ?? '';
        this.cat = event?.cat ?? '';
        this.desc = event?.desc ?? '';
        this.remind = event?.remind ?? '';
    }

    /**
     * Compares this snapshot against a current state instance.
     * Returns true if any field differs from the original event values.
     * @param {CalEventEditState} current
     * @returns {boolean}
     */
    isDirty(current) {
        return (
            this.label !== current.label ||
            this.date !== current.date ||
            this.time !== current.time ||
            this.cat !== current.cat ||
            this.desc !== current.desc ||
            this.remind !== current.remind
        );
    }
}
